module.exports = __webpack_public_path__ + "img/nature-61.3259e81d.jpg";